import React from 'react';

import LightBulbSVG from './assets/light-bulb-loading.svg';

export const LightBulbLoading = () => (
  <div data-testid="light-bulb-loading">
    <img src={LightBulbSVG} alt="" />
  </div>
);
